import type { App } from 'vue';
import { Button } from './Button';
import Antd, {
  // Need
  Button as AntButton,
  Input,
  Layout,
  Select,
  Space,
  Switch,
  Affix,
  Tabs,
  Form,
  Table,
  Radio,
} from 'ant-design-vue';

const compList = [AntButton.Group];

export function registerGlobComp(app: App) {
  compList.forEach((comp) => {
    app.component(comp.name || comp.displayName, comp);
  });

  app.use(Antd).use(Input).use(Button).use(Radio).use(Layout).use(Select).use(Space).use(Switch).use(Affix).use(Tabs).use(Form).use(Table);
}
